import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import _ from "lodash";
import { validateAadhaar } from "../../Helper/common";
import AadhaarVerified from "./AadhaarVerified";
import { generate6DigitsAlphanumericCode } from "../../Helper/common";
import "./AadhaarLinked.css";

const AadhaarLinked = ({
  captchaData,
  aadhaarVerified,
  verifyAadhaar,
  verifyOTPHandler,
  handleCaptchaReload,
  handleOTPBack
}) => {
  const [captchaVal, setCaptchaVal] = useState("");
  const [aadhaarData, setAadhaarData] = useState({
    aadhaarNumber: "",
    // captchaCode: "",
  });
  const [errorData, setErrorData] = useState({
    aadhaarNumber: false,
    // captchaCode: false,
  });

  useEffect(() => {
    // getCaptcha();
  }, []);
  const handleAadhaarData = (name, value) => {
    if (name == "aadhaarNumber") {
      const isValid = validateAadhaar(value);
      let data = _.cloneDeep(errorData);
      data[name] = !isValid;
      setErrorData(data);
    } else {
      let data = _.cloneDeep(errorData);
      data[name] = false;
      setErrorData(data);
    }
    let data = _.cloneDeep(aadhaarData);
    data[name] = value;
    setAadhaarData(data);
  };

  const aadhaarPreVerification = (e) => {
    e.preventDefault();
    aadhaarVerificationHandler();
  };
  const aadhaarVerificationHandler = (startTimer) => {
    let hasError = false;
    let updatedErrorData = _.cloneDeep(errorData);
    for (var i in aadhaarData) {
      if (aadhaarData[i] == "") {
        hasError = true;
        updatedErrorData[i] = true;
      }
      // if (i == "captchaCode") {
      //   if (aadhaarData[i] != captchaVal) {
      //     hasError = true;
      //     updatedErrorData[i] = true;
      //   } else {
      //     hasError = false;
      //     updatedErrorData[i] = false;
      //   }
      // }
    }

    setErrorData(updatedErrorData);
    if (!hasError) {
      verifyAadhaar(aadhaarData);
    }
  };

  const verifyOTP = (OTPVal) => {
    verifyOTPHandler(OTPVal);
  };

  const getCaptcha = () => {
    const newCaptcha = generate6DigitsAlphanumericCode();
    setCaptchaVal(newCaptcha);
  };
  const captchaImg = captchaData.captchaCode
    ? "data:image/jpeg;base64," + captchaData.captchaCode
    : "";

  return (
    <>
   {!!(true || aadhaarVerified == false) && <>
      <div className={"form-one  d-block"}>
        <div class="row">
          <div className="col-sm-4 col-md-12 col-xl-4">
            <div className="form-group">
              <div className="floating-label">
                <input
                  type="text"
                  className="form-control"
                  name="aadhaarNumber"
                  id="aadhaarNumber"
                  value={aadhaarData.aadhaarNumber}
                  onChange={(e) =>
                    handleAadhaarData(e.target.name, e.target.value)
                  }
                />
                <label
                  htmlFor="aadhaarNumber"
                  className={aadhaarData.aadhaarNumber && "focused"}
                >
                  Aadhaar Card Number
                  <sup className="text-danger">*</sup>
                </label>
              </div>
              {errorData && errorData.aadhaarNumber === true ? (
                aadhaarData.aadhaarNumber == "" ||
                aadhaarData.aadhaarNumber == null ? (
                  <p className="err text-danger">This field is required</p>
                ) : (
                  <p className="err text-danger">Please provide valid input</p>
                )
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
        {/* <div className="cstm-capcha">
        <div className="row">
          <div className="col-sm-4 col-md-12 col-xl-4">
            <p className="text-muted mb-1">Captcha</p>
          </div>
        </div>
        <div class="row">
          <div className="col-sm-4 col-md-12 col-xl-4">
            <div className="form-group d-flex align-items-center">
              <span type="text" id="generated-captcha">
                {captchaVal}
              </span>
              <div class="capcha-right-sec">
                <i
                class="fas fa-redo cursor-pointer"
                onClick={getCaptcha}
                style={{ marginLeft: "10px", color: "#1570EF" }}
              ></i>
                <span className="refresh-title"> Refresh</span>
              </div>
              
            </div>
          </div>
        </div>

        <div class="row">
          <div className="col-sm-4 col-md-12 col-xl-4">
            <div className="form-group">
              <div className="floating-label">
                <input
                  type="text"
                  className="form-control"
                  name="captchaCode"
                  id="captchaCode"
                  value={aadhaarData.captchaCode}
                  onChange={(e) =>
                    handleAadhaarData(e.target.name, e.target.value)
                  }
                />
                <label
                  htmlFor="captchaCode"
                  className={aadhaarData.captchaCode && "focused"}
                >
                  Enter Code<sup className="text-danger">*</sup>
                </label>
              </div>
              {errorData && errorData.captchaCode === true ? (
                aadhaarData.captchaCode == "" ||
                aadhaarData.captchaCode == null ? (
                  <p className="err text-danger">This field is required</p>
                ) : (
                  <p className="err text-danger">
                    The captcha entered is incorrect
                  </p>
                )
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
        </div> */}
      </div>

      <div className={"form-three  d-block"}>
        <div class="row">
          <div class="col-sm-4 col-md-12 col-xl-4">
            <div className="justify-content-between w-100">
              <div className="row mt-3">
                <div className="col-md-12 d-flex">
                  <button
                    className="btn btn-primary btn-lg mt-3"
                    onClick={(e) => aadhaarPreVerification(e)}
                  >
                    Verify Aadhaar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </>}

      {/* {aadhaarVerified && (
        <AadhaarVerified
          handleResend={aadhaarVerificationHandler}
          verifyOTP={verifyOTP}
          handleOTPBack={handleOTPBack}
        />
      )} */}
    </>
  );
};

export default AadhaarLinked;
